import { Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { Page } from '@components/Page';
import { BankInfoTab } from './components/BankInfoTab';
import { ProfileTab } from './components/ProfileTab';

type TabValue = 'profile' | 'bank_info';

function Settings() {
  const [currentTab, setCurrentTab] = useState<TabValue>('profile');

  function handleTabChange(_: unknown, value: TabValue) {
    setCurrentTab(value);
  }

  return (
    <Page title='Settings'>
      <Tabs value={currentTab} onChange={handleTabChange}>
        <Tab label='Profile' value='profile' />
        <Tab label='Bank Info' value='bank_info' />
      </Tabs>

      {currentTab === 'profile' && <ProfileTab />}

      {currentTab === 'bank_info' && <BankInfoTab />}
    </Page>
  );
}

export { Settings };
